import "./extraBid.scss";
import { useSelector } from "react-redux";
import KayakExtraBid from "../kayak/extraBid";

const ExtraBid = () => {
  const platform = useSelector((state) => state?.metaSearch?.platform);

  const currentPlatform = platform[0]?.id;

  switch (currentPlatform) {
    case "kayak":
      return <KayakExtraBid />;
    default:
      return null;
  }
};
export default ExtraBid;
